import React, {useContext, useEffect} from "react";
import {CustomerTypeContext} from "../../context/customer-type-context";
import analyitics from "../../utils/analytics";
import {useLocation, useParams} from "react-router";
import UrlDecorator from "../../utils/UrlDecorator";

function CustomerTypeSwitch() {
    const [customerType, setCustomerType, availableCustomerTypes, companyOnly] = useContext(CustomerTypeContext);
    const location = useLocation();
    const params = useParams();

    const changeCustomerTypeHandler = (event) => {
        if (event.target.checked) {
            setCustomerType(availableCustomerTypes.person);
            analyitics.sendEvent({
                category: 'Zmiana umowy - prywatnie',
                action: 'Klikniecie',
                label: 'Prywatnie',
                value: 1
            });

        } else {
            setCustomerType(availableCustomerTypes.company);
            analyitics.sendEvent({
                category: 'Zmiana umowy - firma',
                action: 'Klikniecie',
                label: 'Firma',
                value: 1
            });

        }

    }

    function isOfferListPage() {
        return location.pathname === '/lista-ofert';
    }

    function isOfferPage() {
        return params.brand && params.version && params.id;
    }

    useEffect(() => {
        if (isOfferListPage() || isOfferPage()) {
            UrlDecorator.addCustomerType(customerType);
        }
    }, [customerType, location.pathname]);

    useEffect(() => {
        if (isOfferListPage() || isOfferPage()) {
            const urlSearchParams = new URLSearchParams(location.search);
            const customerTypeFromUrl = urlSearchParams.get("customerType");

            if (customerTypeFromUrl === availableCustomerTypes.person
                || customerTypeFromUrl === availableCustomerTypes.company) {

                setCustomerType(customerTypeFromUrl);
            }

        }

    }, [location]);


    const isCompany = customerType === availableCustomerTypes.company;
    const isPerson = customerType === availableCustomerTypes.person;

    return (
        <div id="switch" className="search-toggle-row">
            <span className={"search-toggle-label" + (isCompany ? " active" : "")}>FIRMA</span>
            <button
                type="button"
                className="search-toggle-switch"
                onClick={() => {
                    if (!companyOnly) {
                        changeCustomerTypeHandler({target: {checked: isCompany}});
                    }
                }}
                disabled={companyOnly}
            >
                <span className={"search-toggle-knob" + (isPerson ? " right" : "")}/>
            </button>
            <span className={"search-toggle-label" + (isPerson ? " active" : "")}>KONSUMENT</span>
        </div>
    );
}

export default CustomerTypeSwitch;